import { MemorySearchSettings } from '../memory-search-client/memory-search-client';

export interface AssistantsSourceSettings extends MemorySearchSettings {
  type: 'assistants';
  title?: string;
}
